import type { QueryClient } from '@tanstack/react-query';

export const AUTH_STALE_TIME = 15 * 1_000;

export const authQueryKeys = {
  all: ['auth'] as const,
  subject: (subject: string) => [...authQueryKeys.all, subject] as const,
};

/** Clears (and so cancels) all account-scoped server state on an account change or sign-out,
 *  and retires queued mutations: one paused offline never resumes for the next account. */
export const clearAuthenticatedQueries = (queryClient: QueryClient): void => {
  queryClient.removeQueries({ queryKey: authQueryKeys.all });
  queryClient.getMutationCache().clear();
};

export const syncAuthenticatedSubject = (
  queryClient: QueryClient,
  previous: string | null | undefined,
  next: string | null,
): string | null => {
  if (previous !== undefined && previous !== next) {
    clearAuthenticatedQueries(queryClient);
  }
  return next;
};
